import Button from "../components/button/Button";
import { ButtonGroup } from "../components/button/ButtonGroup";
import EksternLinkButton from "../components/button/EksternLinkButton";
import { useTranslation } from "react-i18next";
import { FallbackProps } from "react-error-boundary";
import { useEffect } from "react";
import { logFrontendToBackend } from "./logFrontendToBackend";
import { ErrorAction, track } from "../api/tracking";
import { ApiError } from "../api/api.utils";
import { Feilside, FeilSideProps } from "./Feilside";
import layoutStyles from "../components/Layout/Layout.module.scss";
import { LoggLevel } from "../api/apiTypes";

type CustomFallbackProps = FallbackProps & {
  anmeldelseId?: string;
};

export const FallbackComponent = ({
  error,
  anmeldelseId,
}: CustomFallbackProps) => {
  const { t } = useTranslation("skjematekst", {
    keyPrefix: "feilside",
  });

  console.error(error);
  useEffect(() => {
    if (
      error instanceof ApiError &&
      error.status &&
      error.status >= 400 &&
      error.status <= 499
    ) {
      logFrontendToBackend(error, LoggLevel.WARN, anmeldelseId);
      track.error(ErrorAction.ErrorBoundary, `${error.name}: ${error.message}`);
    } else if (error instanceof Error) {
      logFrontendToBackend(error, LoggLevel.ERROR, anmeldelseId);
      track.error(ErrorAction.ErrorBoundary, `${error.name}: ${error.message}`);
    }
  }, [anmeldelseId, error]);

  const finnFeilmelding = (): Omit<FeilSideProps, "children"> => {
    if (error instanceof ApiError) {
      console.error("ERRORSTATUS", error.status);

      switch (error.status) {
        case 403:
          return {
            header: t("forbidden.tittel"),
            infotekst: t("forbidden.info"),
          };
        case 404:
          return {
            header: t("notFound.tittel"),
            infotekst: t("notFound.info"),
            sidetittel: "404",
          };
      }
    }

    return {
      header: t("default.tittel"),
      infotekst: t("default.info"),
    };
  };

  const feilmeldingForStatus = finnFeilmelding();

  return (
    <main id="content" className={layoutStyles.content}>
      <Feilside {...feilmeldingForStatus}>
        <ButtonGroup>
          <Button
            icon={"autorenew"}
            text={t("knapper.lastInn")}
            onClick={() => window.location.reload()}
            data-testid={"fallbackRefresh"}
            trackingName={"Refresh i fallback"}
          />
          <EksternLinkButton
            text={t("knapper.forsiden")}
            buttonType={"secondary"}
            navigateTo={"/"}
            data-testid={"fallbackTilForsiden"}
            trackingName={"Til forsiden i fallback"}
          />
        </ButtonGroup>
      </Feilside>
    </main>
  );
};
